import React from 'react';
import classNames from 'classnames';
import getResizeImageUrl from '../../../services/utils/getResizeImageUrl';
import styles from './promo-card.css';
var PromoCard = function (_a) {
    var _b, _c, _d;
    var _e = _a.title, title = _e === void 0 ? '' : _e, _f = _a.description, description = _f === void 0 ? '' : _f, _g = _a.img, img = _g === void 0 ? '' : _g, _h = _a.buttonText, buttonText = _h === void 0 ? '' : _h, _j = _a.href, href = _j === void 0 ? '' : _j, _k = _a.classes, classes = _k === void 0 ? {
        root: '',
        image: '',
        body: ''
    } : _k, _l = _a.onClick, onClick = _l === void 0 ? function () { } : _l;
    return React.createElement("div", { className: classNames((_b = {},
            _b[styles.root] = true,
            _b[classes.root] = !!classes.root,
            _b)) },
        React.createElement("div", { className: styles.imageWrapper },
            React.createElement("img", { src: getResizeImageUrl({ imageCabinId: img }), draggable: 'false', alt: title, title: title, className: classNames((_c = {},
                    _c[styles.image] = true,
                    _c[classes.image] = !!classes.image,
                    _c)) })),
        React.createElement("div", { className: classNames((_d = {},
                _d[styles.body] = true,
                _d[classes.body] = !!classes.body,
                _d)) },
            (title || description) && React.createElement("div", null,
                title && React.createElement("p", { className: styles.title, dangerouslySetInnerHTML: {
                        __html: title
                    } }),
                description && React.createElement("p", { className: styles.description, dangerouslySetInnerHTML: {
                        __html: description
                    } })),
            buttonText && React.createElement("a", { href: href, className: styles.btn, onClick: onClick, dangerouslySetInnerHTML: {
                    __html: buttonText
                } })));
};
export default React.memo(PromoCard);
